<template>
    <v-container fluid fill-height full-width class="pa-0">
         <v-card class="black--text" min-height="100vh" color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black text-uppercase black--text">Order Id - {{orderRecord.id}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip label color="black" text-color="amber" class="title font-weight-bold text-uppercase"> Order Detail </v-chip>
            </v-toolbar>
            <v-row class="ma-0 mt-5 pt-5">
            <v-col md=6 sm=6 cos=12 :class='orderRecord.status=="approved" ? "" : "ma-auto"'>
                <v-card outlined="">
                    <v-simple-table dense>
                        <template v-slot:default>
                            <tbody class="caption">
                                <tr><td class="subtitle-1 font-weight-light py-2">Product</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.productName}}</td></tr>
                                <!--<tr><td class="subtitle-1 font-weight-light py-2">Product Nature</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.productNature}}</td></tr>-->
                                <tr><td class="subtitle-1 font-weight-light py-2">Order By</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.customer}}</td></tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Order Type</td><td class="subtitle-1 font-weight-light py-2 text-uppercase">{{orderRecord.orderType}}-{{orderRecord.conditionType}}</td></tr>
                                <!--<tr><td class="subtitle-1 font-weight-light py-2">Order Condition</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.conditionType}}</td></tr>-->
                                <tr><td class="subtitle-1 font-weight-light py-2">Payment Condition</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.paymentCond}}</td></tr>  
                                <tr><td class="subtitle-1 font-weight-light py-1">Location</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.location}}</td></tr>
                                <!--<tr><td class="subtitle-1 font-weight-light py-2">Offer Loading Date</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.oLoadingDate}}</td></tr>-->  
                                <!--<tr><td class="subtitle-1 font-weight-light py-1">Offer Payment Date</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.oPaymentDate}}</td></tr>-->
                                <tr><td class="subtitle-1 font-weight-light py-2">Offer Qty</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.oQty}}</td></tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Offer Rate</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.oRate}}</td></tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Demand Rate</td><td class="subtitle-1 font-weight-light py-2">{{orderRecord.dRate}}</td></tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Final Qty</td>
                                    <td class="subtitle-1 font-weight-light py-2" v-if="orderRecord.fQty =='' || orderRecord.fQty == null || store.state.role == 'admin'">
                                        <v-text-field v-model="fQty" label="Final Qty / Tons" outlined color="amber" dense hide-details></v-text-field>
                                    </td>
                                    <td class="subtitle-1 font-weight-light py-2" v-else>{{orderRecord.fQty}}</td>
                                </tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Final Rate</td>
                                    <td class="subtitle-1 font-weight-light py-2" v-if="orderRecord.fRate =='' || orderRecord.fRate == null || store.state.role == 'admin'">
                                        <v-text-field v-model="fRate" label="Final Rate" outlined color="amber" dense hide-details></v-text-field>
                                    </td>
                                    <td class="subtitle-1 font-weight-light py-2" v-else>{{orderRecord.fRate}}</td>
                                </tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Final Loading Date</td>
                                    <td class="subtitle-1 font-weight-light py-2" v-if="orderRecord.fLoadingDate =='' || orderRecord.fLoadingDate == null || store.state.role == 'admin'">
                                        <v-menu ref="fLoadingDateMenu" v-model="fLoadingDateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="fLoadingDate" label="Final Loading Date"  outlined prepend-inner-icon="mdi-calendar-range" color="amber"
                                                readonly v-on="on" dense hide-details></v-text-field>
                                            </template>
                                            <v-date-picker color="amber" v-model="fLoadingDate" scrollable :min="new Date().toISOString().substr(0, 10)" ></v-date-picker>
                                        </v-menu>
                                    </td>
                                    <td class="subtitle-1 font-weight-light py-2" v-else>{{orderRecord.fLoadingDate}}</td>
                                </tr>
                                <tr><td class="subtitle-1 font-weight-light py-2">Final Payment Date</td>
                                    <td class="subtitle-1 font-weight-light py-2" v-if="orderRecord.fPaymentDate =='' || orderRecord.fPaymentDate == null || store.state.role == 'admin'">
                                        <v-menu ref="fPaymentDateMenu" v-model="fPaymentDateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="fPaymentDate" label="Final Payment Date"  outlined prepend-inner-icon="mdi-calendar-range" color="amber"
                                                readonly v-on="on" dense hide-details></v-text-field>
                                            </template>
                                            <v-date-picker color="amber" v-model="fPaymentDate" scrollable :min="new Date().toISOString().substr(0, 10)" ></v-date-picker>
                                        </v-menu>
                                    </td>
                                    <td class="subtitle-1 font-weight-light py-2" v-else>{{orderRecord.fPaymentDate}}</td>
                                </tr>
                                <!--<tr v-if="store.state.role == 'admin'">
                                    <td class="subtitle-1 font-weight-light py-2">Order Manage By</td>
                                    <td class="subtitle-1 font-weight-light py-2">
                                        {{orderRecord.manageBy}}
                                    </td>
                                </tr>-->
                            </tbody>
                        </template>
                    </v-simple-table>
                     <v-col cols=12 md=12 lg=12 sm=12 class="text-right">
                        <v-btn  v-if="orderRecord.fQty == null || orderRecord.fRate == null || orderRecord.fLoadingDate == null || orderRecord.fPaymentDate == null || store.state.role == 'admin'" color="amber" class="black--text" :loading="loading" @click="Save()">Save</v-btn>
                    </v-col>
                </v-card>
            </v-col>
            <v-col v-if="orderRecord.status =='approved'" cols=12 md="6" sm=6>
                <v-card color="white">
                    <v-toolbar color="white" flat min-height="auto">
                        <h2> ADDED PARTIES</h2>
                        <v-spacer></v-spacer>
                         <v-btn color="amber" @click="Send()">Send Email</v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table :headers="orderPartyHeader" :items="orderPartyData" :items-per-page="5" class="elevation-0"></v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
            </v-row>
        </v-card>
        <span style="display:none;">{{checkAndFetch}}{{checkandfetchrecords}}</span>
    </v-container>
  
</template>

<script>
import { SERVER_API } from '../../API'
import {store} from '../../store'
import {bus} from '../../main'
    export default {
        //name:'purchaseFormA',
        created(){
            window.addEventListener('keyup', event => {
                if(event.which === 27){
                    this.Close();
                }
                if(event.which === 13){
                    this.Save();
                }
            })
        },
        props:['orderId'],
        computed:{
            checkAndFetch(){
               return this.fetchedbyid();
            },
            checkandfetchrecords(){
                return this.fetchAddedParty();
            },
        },
        data(){
            return{
                loading:false,
                fPaymentDateMenu:false,
                fLoadingDateMenu:false,
                fRate:'',
                fQty:'',
                fLoadingDate:'',
                fPaymentDate:'',

                orderRecord:'',
                store:store,

                //Add Party
                orderPartyData:[],
                orderPartyHeader: [
                    {text: 'orderId', align: 'left', value: 'orderId',},
                    {text: 'Party', align: 'left', value: 'partyName',},
                    {text: 'Location', align: 'left', value: 'partyLocation',},
                    {text: 'QTY/Tons.', align: 'left', value: 'qty',},
                ]
            }
        },
        methods:{
            async Send(){
                try{
                    const response = await this.$http.post(SERVER_API+'/order/sendemail/'+this.orderId);
                    this.$emit('Response', response.data);
                }catch(error){
                    alert(error);
                }
            },
            async fetchAddedParty(){
                if(this.orderRecord.status == 'approved'){
                    try{
                        const Response = await this.$http.get(SERVER_API+'/order/party/records/'+this.orderId);
                        this.orderPartyData = Response.data.data;
                        bus.$emit('notify',true);
                    }catch(error){
                        alert(error);
                    }
                }
            },
            async fetchedbyid(){
                if(this.orderId != ''){
                    const Response = await this.$http.get(SERVER_API+'/order/saleformb/fetchbyid/'+this.orderId);
                    this.orderRecord = Response.data.data;
                    this.fRate = Response.data.data.fRate;
                    this.fQty = Response.data.data.fQty;
                    this.fLoadingDate = Response.data.data.fLoadingDate;
                    this.fPaymentDate = Response.data.data.fPaymentDate;
                }
            },
            Close(){
                this.finalRate= this.orderRecord.pFinalRate;
                this.finalQty= this.orderRecord.finalQty;
                this.$emit('Close', false);
            },
            async Save(){
                try{
                    this.loading = true;
                    const Response = await this.$http.put(SERVER_API+'/order/update',{
                        id:this.orderId,
                        fRate: this.fRate,
                        fQty: this.fQty,
                        fLoadingDate: this.fLoadingDate,
                        fPaymentDate: this.fPaymentDate,
                    });
                    this.loading = false;
                    bus.$emit('notify',true);
                    this.$emit('Response', Response.data);
                }catch(error){
                    alert(error);
                }
            }
        }
    }
</script>
<style scoped>
.caption tr td{
    font-size: 13px;
    font-weight: bold;
}
.orderTableHeadding{
    background: #e0e0e0 !important;
    color:#000;
    font-weight: 900;
    text-transform: uppercase;
}
</style>